// extracted by mini-css-extract-plugin
module.exports = {"root":"footer_root__JubZ9","inner":"footer_inner__Zu_p_","copy":"footer_copy__303hR","mail":"footer_mail__2LRHI","note":"footer_note__3QOc5","top":"footer_top__29Q3x"};